<template>
  <div v-if="showConclusion" class="badge" :class="resultStatusClass">
    {{ statusName }}
  </div>
</template>
<script>

export default {
  name: 'ResultConclusion',
  props: {
    result: {
      required: true,
      type: Object
    }
  },
  computed: {
    resultStatusClass() {
      return {
        pending: `badge-info`,
        not_passed: `badge-danger`,
        passed: `badge-success`
      }[this.result.status]
    },
    showConclusion(){
      return ['passed', 'not_passed'].includes(this.result.status)
    },
    statusName(){
      switch (this.result.status) {
        case 'pending': return this.$t('js.result.conclusion.pending');
        case 'passed': return this.$t('js.result.conclusion.passed');
        case 'not_passed': return this.$t('js.result.conclusion.not_passed');
      }
    },
  }
}
</script>
